/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-20 14:44:35
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-04-01 20:12:51
 * @FilePath: /designcenter/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// import { initProject } from '@/api/modules/project'
// import {useProjectStore} from '@/store/project'
// import { useUserStore } from '@/store/user'
// import { storeToRefs } from 'pinia'
// import { handleFsLink } from '@/utils/'

import Layout from '@/layout/index.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/design-center',
    children: [
      {
        path: 'design-center',
        name: 'DesignCenter',
        meta: { title: '设计中心', menuId: 'design-center' },
        component: () => import('../views/designCenter/index.vue'),
      },
      {
        path: 'product-catalog',
        name: 'ProductCatalog',
        meta: { title: '产品清单', menuId: 'ProductCatalog' },
        component: () => import('../views/product-catalog/index.vue'),
      },
      {
        path: 'project',
        name: 'Project',
        meta: { title: '项目管理', menuId: 'ProjectManage' },
        component: () => import('../views/project/index.vue'),
      },
      {
        path: 'template-manage',
        name: 'TemplateManage',
        meta: { title: '模板管理' },
        component: () => import('../views/templateManage/index.vue'),
      },
      {
        path: 'template-config',
        name: 'TemplateConfig',
        meta: { title: '模板配置' },
        component: () => import('../views/templateManage/components/TemplateConfig/index.vue'),
      },
      {
        path: '/operation-manual',
        name: 'OperationManual',
        component: () => import('@/views/operation-manual/index.vue'),
        meta: {
          layout: 'manual', // 使用特殊布局
        },
      },
    ],
  },
  {
    path: '/pdf-export',
    name: 'PdfExport',
    meta: { title: 'PDF导出' },
    component: () => import('../views/pdf-export/index.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
